<template>
	<main class="school-mgn-list" style="background: #f5f5fb;">
		<section class="list-area">
			<div class="list-area-otis" style="height:auto" _p="x-10px y-10px">
        <el-form :inline="true" class="form" ref="filter_form" :model="filter_form">
          <el-form-item prop="title">
            <InputTopTip v-model="filter_form.title" placeholder="点评名称">
              <el-input
                v-model="filter_form.title"
                class="width-264"
                @input="(page = 1), refreshDataList()"
                size="small"
                clearable
              ></el-input>
            </InputTopTip>
          </el-form-item>

          <el-form-item prop="option_cate">
            <InputTopTip v-model="filter_form.option_cate" placeholder="点评类型">
              <el-select
                v-model="filter_form.option_cate"
                size="small"
                placeholder=""
                class="width-121"
                @change=";(page = 1), refreshDataList()"
                clearable
              >
                <el-option v-for="item in category" :key="item.id" :label="item?.title" :value="item.id"></el-option>
              </el-select>
            </InputTopTip>
          </el-form-item>

        </el-form>
        <div style="display: flex; margin-left: auto;">
          <el-button
            type="primary"
            @click=";(page = 1), refreshDataList()"
            size="small"
            class="action-btn"
            style="margin-right: 15px; width: 70px;"
            >搜索</el-button
          >
          <el-button @click="restForm('filter_form')" size="small" style="width: 70px;">重置</el-button>
        </div>
			</div>
      <div class="table">
        <div class="table-header">
          <div _flex="~">
            <el-button
              type="primary"
              @click="(newVisible = true)"
              size="small"
              v-permission="'SA21002'"
            >
              <i class="el-icon-plus" style="margin-right: 7px;"></i>新建
            </el-button>
          </div>

          <el-button
            v-if="multipleSelection.length >= 1 && $permissions(['SA21005'])"
            @click="deleteFileStorageAll()"
            size="small"
            :disabled="multipleSelection.length <= 0"
            :style="multipleSelection.length <= 0 && 'color: #4b4b4b !important;background: #9f9f9f !important'"
          >
            <i class="el-icon-delete" style="margin-right: 7px;"></i>批量删除
          </el-button>
        </div>

        <el-table
          :data="tableData"
          ref="multipleTable"
          stripe
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          width="100%"
        >
          <el-table-column type="selection"	width="55"	align="center" :key="'selection'" v-if="$permissions(['SA21005'])"></el-table-column>
          <el-table-column prop="title" label="点评项" align="left"></el-table-column>
          <el-table-column label="点评类型"	align="left">
            <template slot-scope="{ row }">
              <div>{{ row?.option_type || "" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="分值"	align="left"></el-table-column>
          <el-table-column label="分类"	align="left">
            <template slot-scope="{ row }">
              <div>{{ row?.option_cate?.title || category?.find(item => item.id == row.cate_id)?.title || "" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="icon_path" label="图标" align="center">
            <template slot-scope="{ row }">
              <img :src="row?.icon_path?.url" _w="50px" _h="50px" _border="rounded-[1100px]">
            </template>
          </el-table-column>
          <el-table-column prop="updated_at" label="修改时间" align="left"></el-table-column>
          <template v-if="$permissions(['SA21003', 'SA21004'])">
            <el-table-column label="操作" align="center">
              <template slot-scope="{ row }">
                <div style="display: flex; justify-content: center;">
                  <el-tooltip placement="top" effect="light" v-permission="'SA21003'">
                    <div slot="content">编辑</div>
                    <div
                      class="icon-circle"
                      style="color: #3f6af7; background: white;"
                      _border="1px solid [#ebeef5]"
                      @click="editParamsEvent(row)"
                    >
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-iconoutlinesetting"></use>
                      </svg>
                    </div>
                  </el-tooltip>

                  <el-tooltip placement="top" effect="light" v-permission="'SA21004'">
                    <div slot="content">删除</div>
                    <div class="icon-circle" @click="deleteFileStorageAll(row?.id)">
                      <svg
                        class="icon"
                        aria-hidden="true"
                        style="width: 100%; height: 100%; outline: none; box-shadow: none;"
                      >
                        <use xlink:href="#icon-deltred"></use>
                      </svg>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>

        <div class="pagination-page">
          <span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
          <el-pagination
            class="pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :total="totalItems"
            :current-page.sync="page"
            :page-sizes="[10, 20, 50, 100]"
            layout="prev,pager,next,jumper,sizes"
            style="margin-top: 21px; margin-left: 10px;"
          >
          </el-pagination>
        </div>
      </div>
		</section>
    <el-dialog
			class="scope-dialog"
			:width="'740px'"
			@close="beforeNewClose"
			:close-on-click-modal="false"
			:visible.sync="newVisible"
			:title="`${editID ? '编辑' : '新建'}点评项`"
		>
      <el-divider></el-divider>
      <el-form :model="newParams" :rules="paramsRules" ref="newParams" label-width="90px" _flex="~ col">
        <el-form-item label="图标：" prop="icon_path" _m="t-20px">
          <div v-if="!newParams?.icon_path?.url" @click="popup()" _w="70px" _h="70px" _cursor="pointer" _border="rounded-[1100px]" _bg="[#F1F1F1]" _flex="~ col justify-center items-center">
            <el-icon class="el-icon-circle-plus"></el-icon>
            <p _text="12px [#908F8F]" _m="t-5px">添加图片</p>
          </div>
          <div v-else _flex="~ items-end">
            <img @click="popup()" :src="newParams.icon_path?.url" _cursor="pointer" _w="70px" _h="70px" _border="rounded-[1100px]" _m="r-15px" >
            <el-button @click="imgEdit = true" size="mini" icon="el-icon-edit">编辑</el-button>
          </div>
				</el-form-item>
				<el-form-item label="名称：" prop="title" _m="t-30px">
					<InputTopTip v-model="newParams.title" placeholder="请输入名称">
						<el-input
							v-model="newParams.title"
							oninput="value=value.trim()"
							size="small"
							style="width:464px"
							:maxlength="50"
							placeholder=""
						></el-input>
					</InputTopTip>
				</el-form-item>
        <el-form-item label="点评类型：" _m="t-30px">
          <div _flex="~ wrap">
            <span
              v-for="(type, index) in ['表扬', '待改进']"
              :key="index"
              _border="rounded-[8px]"
              style="min-width:80px"
              _h="40px"
              _flex="~ items-center justify-center"
              _m="r-15px b-15px"
              _cursor="pointer"
              _p="x-10px"
              _bg="[#EEEEEE]"
              :class="['tag', activeScoreType === type && 'tag-active']"
              @click="activeScoreType = type"
            >
              {{ type }}
            </span>
          </div>
				</el-form-item>
        <el-form-item label="分值：" prop="score" _m="t-15px">
          <div _flex="~ wrap">
            <span
              v-for="(item, index) in [...score, { title: customValue, disabled: true, isVisible: score?.length > 11 || scoreInputVisible  }]"
              :key="index"
              _bg="[#EEEEEE]"
              _border="rounded-[8px]"
              style="min-width:80px"
              _h="40px"
              _flex="~ items-center justify-center"
              _m="r-15px b-15px"
              _cursor="pointer"
              _p="x-10px"
              :class="['tag', parseFloat(newParams.score) === parseFloat(item.title) && 'tag-active']"
              :style="{ order: index }"
              @click="clickScoreOrCategory('score', item)"
              @dblclick="dbClickScoreOrCategory('score', item, index, $event)"
              v-show="((activeScoreType === '表扬' ? item.title > 0 : item.title <= 0) || (index >= 11 && scoreInputVisible)) && !item?.isVisible"
            >
               {{ item.title > 0 ? '+' : '' }}{{ item.title }}
              <div v-if="!item.disabled" _m="l-10px" @click.stop="deleteScoreOrCategory('score', item)" >
                <el-icon class="el-icon-close"/>
              </div>
            </span>
            <el-input
              v-model="scoreValue"
              v-if="scoreInputVisible"
              size="middle"
              ref="scoreInput"
              @input="handleInput"
              @blur="inputBlur('score')"
              :style="{ order: scoreInputIndex >= 0 ? scoreInputIndex : score.length - 1, width: `${ wdith ? wdith :'68' }px`, marginRight: '15px' }"
              @keydown.enter.native.prevent="inputEnter('score')"
            ></el-input>
            <span
              v-if="showCustomChangeScoreButton"
              _bg="[#EEEEEE]"
              _border="rounded-[8px]"
              style="min-width:100px"
              _h="40px"
              _flex="~ items-center justify-center"
              _m="r-15px b-15px"
              _cursor="pointer"
              _p="x-10px"
              _order="999"
              @click="customChangeScore"
            >
              自定义{{ activeScoreType === '表扬' ? '加' : '减' }}分
            </span>
          </div>
				</el-form-item>
        <el-form-item label="分类：" prop="cate_id" _m="t-15px">
          <div _flex="~ wrap">
            <span
              v-for="(item, index) in [...category, { id: null, title: '添加分类', disabled: true }]"
              :key="item?.id"
              _bg="[#EEEEEE]"
              _border="rounded-[8px]"
              style="min-width:68px"
              _h="40px"
              _flex="~ items-center justify-center"
              _m="r-15px b-15px"
              _p="x-10px"
              _cursor="pointer"
              :class="['tag', newParams.cate_id === item?.id && 'tag-active']"
              :style="{ order: index }"
              @click="clickScoreOrCategory('category', item)"
              @dblclick="dbClickScoreOrCategory('category', item, index, $event)"
              v-show="!item?.isVisible"
            >
              {{ item?.title }}
              <div v-if="!item?.disabled" _m="l-10px" @click.stop="deleteScoreOrCategory('category', item)" >
                <el-icon class="el-icon-close"/>
              </div>
            </span>
            <el-input
              v-model="categoryValue"
              v-if="categoryInputVisible"
              size="middle"
              ref="categoryInput"
              @blur="inputBlur('category')"
              @keydown.enter.native.prevent="inputEnter('category')"
              :style="{ order: categoryInputIndex >=0 ? categoryInputIndex : category.length - 1, width: `${ wdith ? wdith :'68' }px`, marginRight: '15px' }"
            ></el-input>
          </div>
				</el-form-item>
			</el-form>
      <div style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
				<el-button class="btn-close" @click="newVisible = false" style="width: 80px; height: 32px; line-height: 1px;"
					>取 消</el-button
				>
				<el-button
					class="btn-prim"
					type="primary"
					@click="boxConfirmEvent('newParams')"
					style="height: 32px; line-height: 1px;"
					:disabled="!isNewParamsValid"
					>确定</el-button
				>
			</div>
    </el-dialog>

    <el-dialog
			class="scope-dialog"
			:width="'740px'"
			:close-on-click-modal="false"
			:visible.sync="imgEdit"
			:title="`图片编辑`"
      :key="newParams.icon_path?.url"
		>
      <el-divider></el-divider>
      <CropperVue ref="cropper" :src="newParams.icon_path?.url" />
      <div _flex="~ items-center justify-center" _m="y-20px">
				<el-button class="btn-close" @click="imgEdit = false" style="height: 32px; line-height: 1px;"
					>取 消</el-button
				>
				<el-button
					class="btn-prim"
					type="primary"
          size="small"
          :loading="imgEditLoading"
					@click="imgEditConfirm"
					>确定</el-button
				>
			</div>
    </el-dialog>
    <!-- <ResourceDialog
			v-if="tikuManager.objIdData[id].acceptFileType && tikuManager.objIdData[id].resourceDialogShow"
			:visible="tikuManager.objIdData[id].resourceDialogShow"
			@update:visible="updateVsb"
			:fileType="tikuManager.objIdData[id].acceptFileType"
			width="1200px"
			top="8vh"
		></ResourceDialog> -->
    <div ref="dialogRefBox" style="z-index:9999; position: absolute"></div>
    <!-- 隐藏的文件上传input -->
    <input type="file" accept="image/*" ref="uploadInputRef" style="display: none" @change="handleFileChange" />
	</main>

</template>
<script>
import { mapValues } from 'lodash'
import { scoreMap, paramsRules, customValue } from './const'
import ResourceDialog from '@/components/ResourceDialog/index.vue'
import CropperVue from './Cropper.vue'
import { tikuManager } from '@/observable'
// import validateCommon from '@/components/ResourceDialog/validateCommon.js'
import uuid from '@/utils/uuid'
// import { ResourcesDialogShadowElement } from 'file-explorer'

export default {
  components: { ResourceDialog, CropperVue },
	data() {
		return {
      category: [], 
      score: [], 
      paramsRules, customValue, scoreMap,
      id: uuid(),
			tableData: [],
			multipleSelection: [],
			page: 1,
			totalItems: 0,
			pageSize: 10,
			filter_form: {
        title: '',
        option_cate: ''
      },
      editID: '',
      newVisible: false, // 新建、编辑
      imgEdit: false, // 图片编辑
      imgEditLoading: false, // 图片裁剪中
      newParams: { // 新建编辑表单
        icon_path: {
          url: '',
          node: ''
        },
        title: '',
        score: '',
        cate_id: ''
      },
      categoryInputVisible: false, // 分类输入框显示隐藏
      scoreInputVisible: false, // 分值输入框显示隐藏
      scoreValue: '', // 分值输入框
      categoryValue: '', // 分类输入框
      categoryID: -1, // 分类输入id
      scoreInputMode: 'new', // 分值输入框新建、编辑模式
      categoryInputMode: 'new', // 分类输入框新建、编辑模式
      scoreInputIndex: -1,
      categoryInputIndex: -1,
      wdith: '', // 记录span的宽度
      activeScoreType: '表扬', // 点评类型：表扬、待改进
		}
	},
  watch: {
    newVisible(val) {
      if (val) {
        this.getScoreOrCategory()
      }
    }
  },
  computed: {
		tikuManager() {
			return tikuManager
		},
    isNewParamsValid() {
      const { icon_path, title, score, cate_id } = this.newParams
      return !!(icon_path?.url && title && (score !== '' && score !== null && score !== undefined) && cate_id)
    },
    showCustomChangeScoreButton() {
      if (this.score.length < 12) return true
      const currentCustomItem = this.score[11]
      const isEditing = this.scoreInputVisible && this.scoreInputIndex === 11
      if (isEditing) return false
      if (currentCustomItem.title <= 0 && this.activeScoreType === '表扬') {
        return true
      }
      if (currentCustomItem.title > 0 && this.activeScoreType === '待改进') {
        return true
      }
      return false
    }
	},
	created() {
    this.score = JSON.parse(JSON.stringify(this.scoreMap))
    this.tikuManager.objIdData = {
			...this.tikuManager.objIdData,
			[this.id]: {
				acceptFileType: '',
				deleteUpload: () => {},
				urlData: [],
				richTextContentMultiple: (_) => {},
        resourceDialogShow: false,
        beforeUpload: () => { },
        uploadAcceptFileType: ''
			}
		}
    try {
      const { option_cate, page, page_size, title } = this.$store.state.searchParams[this.$route.name]
      this.page = page
      this.page_size = page_size
      this.filter_form.title = title
      this.filter_form.option_cate = option_cate
      this.refreshDataList()
    } catch (_) {
      this.refreshDataList()
    }
	},
  async mounted() {
    await this.getScoreOrCategory()
    await this.$nextTick()
    // this.tikuManager.objIdData[this.id].richTextContentMultiple = ({ response }) => {
    //   // 选择图片后打开裁剪弹窗
    //   this.newParams.icon_path = { url: response.uri, node: response.node }
    //   this.imgEdit = true
    // }
  },
	methods: {
    // 获取分类的子配置选项
    async getScoreOrCategory() {
      const { data } = await this.$api.user.httpGet(`/eval/attendance-cate`)
      this.category = data
    },
    // 点击选中
    clickScoreOrCategory(type, e) {
      if (type == 'score') {
        this.scoreValue = ''
        if (e.title === this.customValue) this.scoreInputVisible = true, this.scoreInputMode = 'new'
        else this.newParams.score = e.title, this.scoreInputVisible = false
      }
      if (type == 'category') {
        this.categoryValue = ''
        if (e.id === null) this.categoryInputVisible = true, this.categoryInputMode = 'new'
        else this.newParams.cate_id = e.id, this.categoryInputVisible = false
      }
      this.inputfocus(`${type}Input`)
    },
    // 双击
    dbClickScoreOrCategory(type, e, index, element) {
      if (e.disabled) return
      this[`${type}Value`] = e.title
      this[`${type}ID`] = e.id
      this[`${type}InputVisible`] = true
      this[`${type}InputMode`] = 'edit'
      this[`${type}InputIndex`] = index
      this.wdith = element.target.clientWidth // 记录span的宽度
      e.isVisible = true // 隐藏span标签
      this.inputfocus(`${type}Input`)
    },
    // 失去聚焦-PS:反正都要清空不需要区分
    async inputBlur(type) {
      await this.inputEvent(type)
      this.scoreInputVisible = false
      this.categoryInputVisible = false
      if (this.scoreInputIndex >= 0) this.score[this.scoreInputIndex].isVisible = false
      if (this.categoryInputIndex >= 0) this.category[this.categoryInputIndex].isVisible = false
      this.scoreInputIndex = -1
      this.categoryInputIndex = -1
      this.wdith = ''
    },
    // 聚焦
    async inputfocus(key) {
      await this.$nextTick()
      this.$refs[key]?.focus()
    },
    // 分值、分类删除
    async deleteScoreOrCategory(type, e) {
      if (type == 'score') {
        if (parseFloat(this.newParams.score) == parseFloat(e.title)) this.newParams.score = ''
        const index = this.score.findIndex(item => item.title == e.title)
        this.score.splice(index, 1)
      }
      if (type == 'category') {
        await this.$api.user.httpDelete(`/eval/attendance-cate/${e.id}`)
        if (this.newParams.cate_id == e.id) this.newParams.cate_id = ''
        const index = this.category.findIndex(item => item.id == e.id)
        this.category.splice(index, 1)
      }
    },
    // 自定义加减分
    customChangeScore() {
      if (this.score.length < 12) {
        this.scoreInputVisible = true
        this.scoreInputMode = 'new'
        this.inputfocus('scoreInput')
        return
      }

      if (this.score.length >= 12) {
        const score = this.score[11]
        const isPraise = this.activeScoreType === '表扬'
        const currentValue = parseFloat(score.title)
        
        // 如果当前值不符合新类型规则，输入框为空
        const shouldClear = (isPraise && currentValue <= 0) || (!isPraise && currentValue > 0)
        
        this.scoreValue = shouldClear ? '' : score.title
        this.scoreInputVisible = true
        this.scoreInputMode = 'edit'
        this.scoreInputIndex = 11
        score.isVisible = true
        this.inputfocus('scoreInput')
      }
    },
    // 回车
    async inputEnter() {
      this.scoreInputVisible = false
      this.categoryInputVisible = false
    },
    async inputEvent(type) {
      if (type == 'score') {
        if (!this.scoreValue) return
        
        const score = this.score.find(item => Number(item.title) === Number(this.scoreValue))
        if (score) {
          this.newParams.score = parseFloat(score.title)
          return
        }
        const item = { title: this.scoreValue, disabled: false }
        if (this.scoreInputMode == 'new') {
          this.score.push(item)
        }
        if (this.scoreInputMode == 'edit') {
          this.score[this.scoreInputIndex].title = this.scoreValue
          this.score[this.scoreInputIndex].isVisible = false
        }
        this.newParams.score = item.title
        this.scoreInputVisible = false
      }
      if (type == 'category') {
        if (!this.categoryValue) {
          this.$message.warning('请输入分类')
          return
        }
        const isHas = this.category.some(item => item.title == this.categoryValue)
        if (isHas) {
          this.$message.warning('已有该分类')
          return
        }
        // const item = { id: this.category.length + 1, value: this.categoryValue, disabled: false }
        if (this.categoryInputMode == 'new') {
          const data = await this.$api.user.httpPost('/eval/attendance-cate', { title: this.categoryValue })
          this.category.push(data)
          this.newParams.cate_id = data.id
        }
        if (this.categoryInputMode == 'edit') {
          await this.$api.user.httpPut(`/eval/attendance-cate/${this.categoryID}`, { title: this.categoryValue })
          this.category[this.categoryInputIndex].title = this.categoryValue
          this.category[this.categoryInputIndex].isVisible = false
          this.newParams.cate_id = this.categoryID
        }
        this.categoryInputVisible = false
      }
    },
    // 输入限制
    handleInput(val) {
      if (val == '') {
        this.scoreValue = '';
        return;
      }
      let value = val
      const isPraise = this.activeScoreType === '表扬'
      
      // 表扬只能输入正数，去掉负号
      if (isPraise) {
        value = value.replace(/-/g, '')
        this.scoreValue = value
      }
      
      // 待改进只能输入负数或0，自动添加负号
      if (!isPraise && value.length > 0 && value[0] !== '-') {
        if (value === '0' || value.startsWith('0.')) {
          // do nothing
        } else {
          value = '-' + value
          this.scoreValue = value
        }
      }
      
			// 智能输入：处理前导0的情况
      // 如果是 "0" 开头且有多个0，或者"0"后面跟的不是小数点，则只保留一个0
      if (value.length > 1 && value[0] === '0' && value[1] !== '.') {
        // 去掉所有前导0，保留一个
        value = '0' + value.substring(1).replace(/^0+/, '')
        this.scoreValue = value
      }
      // 处理负数的情况："-0" 开头且后面跟的不是小数点
      if (value.length > 2 && value[0] === '-' && value[1] === '0' && value[2] !== '.') {
        // 去掉多余的0，只保留一个0
        value = '-0' + value.substring(2).replace(/^0+/, '')
        this.scoreValue = value
      }
      // 只允许数字、负号、小数点
      const cleaned = value.replace(/[^\d.-]/g, '')
      if (cleaned !== value) {
        value = cleaned
        this.scoreValue = value
      }
      // 负号只能在开头
      if (value.indexOf('-') > 0) {
        value = value.replace(/-/g, '')
        this.scoreValue = value
      }
      // 限制只有一个负号
      const negativeCount = (value.match(/-/g) || []).length
      if (negativeCount > 1) {
        value = '-' + value.replace(/-/g, '')
        this.scoreValue = value
      }
      // 小数点前必须有数字：处理 "." 或 "-." 的情况
      if (value === '.') {
        value = isPraise ? '0.' : '-0.'
        this.scoreValue = value
      }
      if (value === '-.' && !isPraise) {
        value = '-0.'
        this.scoreValue = value
      }
      // 限制只有一个小数点
      const dotCount = (value.match(/\./g) || []).length
      if (dotCount > 1) {
        const firstDotIndex = value.indexOf('.')
        value = value.substring(0, firstDotIndex + 1) + value.substring(firstDotIndex + 1).replace(/\./g, '')
        this.scoreValue = value
      }
      // 限制小数点后最多2位
      const dotIndex = value.indexOf('.')
      if (dotIndex !== -1 && value.length > dotIndex + 2) {
        value = value.substring(0, dotIndex + 2)
        this.scoreValue = value
      }
      // 转换为数字并限制范围（只在有完整数字时）
      if (value && value !== '-' && value !== '.' && value !== '-.') {
        const num = parseFloat(value)
        if (!isNaN(num)) {
          if (isPraise) {
            if (num < 0) {
              value = '0'
              this.scoreValue = value
            }
            if (num > 99.9) {
              value = '99.9'
              this.scoreValue = value
            }
          } else {
            if (num < -99.9) {
              value = '-99.9'
              this.scoreValue = value
            }
            if (num > 0) {
              value = '0'
              this.scoreValue = value
            }
          }
        }
      }
    },
    // 图片裁剪编辑
    async imgEditConfirm() {
      try {
        this.imgEditLoading = true
        const result = await this.$refs.cropper.handleConfirm()
        // 接口传 node（短链接），显示用 url（长链接）
        this.newParams.icon_path = { url: result.uri, node: result.node }
        this.imgEdit = false
      } finally {
        this.imgEditLoading = false
      }
    },
    // 多媒体
    popup(type = 'image'){
      // 触发文件选择
      this.$refs.uploadInputRef.click()
		},
    // 处理文件选择
    async handleFileChange(event) {
      const file = event.target.files[0]
      if (!file) return
      
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件')
        return
      }
      
      try {
        // 创建本地预览URL
        const localUrl = URL.createObjectURL(file)
        
        // 直接打开裁剪弹窗，传入本地URL
        this.newParams.icon_path = { url: localUrl, node: '' }
        this.imgEdit = true
      } catch (error) {
        this.$message.error('图片加载失败')
        console.error('图片加载失败:', error)
      } finally {
        // 清空input，允许重复选择同一文件
        event.target.value = ''
      }
    },
    updateVsb(v){
			// this.tikuManager.objIdData[this.tikuManager.activeID].resourceDialogShow = v
		},
    // 新建编辑关闭事件
    beforeNewClose() {
      this.$refs['newParams'].resetFields()
      this.score = JSON.parse(JSON.stringify(this.scoreMap))
      this.newParams = mapValues(this.newParams, () => '')
      this.editID = ''
      this.newVisible = false
      this.activeScoreType = '表扬'
    },
    // 表单提交
    boxConfirmEvent(formName) {
			this.$refs[formName].validate(async valid => {
				if (valid) {
          if (this.editID) {
            await this.$api.user.httpPut(`/eval/attendance-option/${this.editID}`, {...this.newParams, icon_path: this.newParams.icon_path?.node})
            this.$message.success('更新成功')
          } else {
            await this.$api.user.httpPost(`/eval/attendance-option`, {...this.newParams, icon_path: this.newParams.icon_path?.node})
          }
					this.beforeNewClose()
          this.refreshDataList()
				} else {
					return false
				}
			})
		},
    // 列表删除-批量、单个
    async deleteFileStorageAll(id) {
      let params = []
      if (id) {
        params = [id]
      } else {
        if (this.multipleSelection.length <= 0) return
        params = this.multipleSelection.map(item => {
          return item.id
        })
      }
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					dangerouslyUseHTMLString: true,
					type: 'warning'
				}
			)
				.then(async () => {
          await Promise.all(params.map(id => this.$api.user.httpDelete(`/eval/attendance-option/${id}`)))
					this.page = 1
					this.refreshDataList()
				})
				.catch(() => {})
		},
    // 列表编辑
    editParamsEvent(row) {
      const { id, icon_path, title, score, cate_id } = row
      this.editID = id
      this.newVisible = true
      this.newParams = { icon_path, title, score, cate_id }
      const isHas = this.score.some(item => item.title == this.newParams.score)
      if (!isHas) {
        this.score.splice(11, 1, {
          title: this.newParams.score,
          disabled: false
        })
      }
      // 根据 score 设置 activeScoreType
      if (score !== undefined && score !== null) {
        this.activeScoreType = score > 0 ? '表扬' : '待改进'
      }
    },
    handleSelectionChange(val, adasd) {
      this.multipleSelection = val
    },
    // 重置
    restForm(name) {
      this.$refs[name].resetFields()
      this.filter_form = mapValues(this.filter_form, () => '')
      this.refreshDataList()
    },
		//获取列表数据
		async refreshDataList() {
      const params = {
				page: this.page,
				page_size: this.pageSize,
        ...this.filter_form,
			}
      this.$store.commit('setSearchParams', { key: this.$route.name, params})
			const { data, meta } = await this.$api.user.httpGet('/eval/attendance-option', params)
			this.totalItems = meta.total
			this.tableData = data
		},
		handleSizeChange(val) {
			this.pageSize = val
			this.refreshDataList()
		},
		handleCurrentChange(page) {
			this.page = page
			this.refreshDataList()
		},

	}
}
</script>
<style lang="scss" scoped>
.school-mgn-list .el-table {
	min-height: 690px;
}
.table {
	margin-top: 10px;
	padding: 20px;
	background: #ffffff;
	display: block;
}
.table-header {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}

/deep/.el-table thead th {
	background-color: #fafafa;
	border-top: 1px solid #fff;
}
.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
.el-form-item {
	margin-bottom: 1px;
}

.pagination-page {
	height: 60px;
	display: flex;
	justify-content: left;
	align-items: left;
}

.icon-circle {
	width: 28px;
	height: 28px;
	border-radius: 100%;
	background: #fff8f5;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.icon-circle:nth-child(2) {
	margin-left: 15px;
}
.tag {
  box-sizing: border-box;
}
.tag:hover {
  background: #FDF4F1;
  color: #FF5E2A;
}
.tag-active {
  background: #FDF4F1;
  color: #FF5E2A;
  border: 2px solid #FF5E2A;
  box-sizing: border-box;
}
.btn-prim.is-disabled,
.btn-prim.is-disabled:hover,
.btn-prim.is-disabled:focus {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>